export default "__VITE_ASSET__DbN6LgSG__"